module.exports = __webpack_public_path__ + "media/bootstrap-icons/thermometer-low-8ce1ccfc.svg";